import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Typography,
  Radio,
  RadioGroup,
  Pagination,
  Grid,
  IconButton,
  Button,
  FormControlLabel,
  Checkbox,
  Divider,
  DialogActions,
  ThemeProvider,
  Dialog,
  createTheme,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { ReactComponent as GenerateButton } from "../../images/generateButton.svg";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";



// TabPanel utility function
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

const theme = createTheme({
  typography: {
    fontFamily: "Manrope, Arial, sans-serif",
    fontSize: 13,
  },
});

function Epics({
  epicsAndSprintsLoading,
  setSelectedParent,
  setEpic,
  setSprint,
  epicsList,
  setEpicsList,
  sprintsList,
  setSprintsList,
  unassignedStories,
  setUnassignedStories,
  selectedUnassignedUserStories,
  setselectedUnassignedUserStories,
  setImportOpen,
  selectedProjectName,
  almConfig,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedEpicOrSprintIndex, setselectedEpicOrSprintIndex] =
    useState(null); // Track selected radio button
  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(1); // Current page
  const [currentUnassignedStoriesPage, setCurrentUnassignedStoiresPage] =
    useState(1);

  // GET ALL EPICS
  const allEpics = epicsList.map((item) => ({
    title: item.summary,
    status: item?.status,
    lastUpdated: item?.updated,
    id: item?.id,
    key: item?.key,
  }));

  //GET ALL SPRINTS
  const allSprints = sprintsList.map((item) => ({
    title: item.name, // All Sprints will have the title "Title"
    status: item?.state,
    id: item?.id,
    path: item?.path,
    // lastUpdated: item?.updated,
  }));

  const itemsPerPage = 8; // 8 items per page (Epics or sprints)
  const storiesPerPage = 6; // 6 items per page (Unassigned stories)

  const totalEpicPages = Math.ceil(epicsList.length / 8);
  const totalSprintPages = Math.ceil(sprintsList.length / 8);
  const totalUnassignedStoriesPage = Math.ceil(
    unassignedStories.length / storiesPerPage
  );

  const handleTabChange = (event, newValue) => {
    setPage(1);
    setTabValue(newValue);
  };

  const handleBack = () => {
    setSelectedParent(null);
    setEpicsList([]);
    setSprintsList([]);
    setUnassignedStories([]);
  };

  // Function to get the paginated epics
  const getPaginatedEpics = (page) => {
    return allEpics.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  };

  // Get epics for the current page
  const paginatedEpics = getPaginatedEpics(page);

  // Function to get the paginated sprints
  const getPaginatedSprints = (page) => {
    return allSprints.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  };

  // Get Sprints for the current page
  const paginatedSprints = getPaginatedSprints(page);

  //HANDLE EPICS BY SELECT RADIO
  const handleEpics = (epic, index) => {
    setSprint(null);
    setEpic(epic);
    setselectedEpicOrSprintIndex(index); // Save selected radio button index
  };

  //HANDLE SPRINTS BY SELECT RADIO
  const handleSprints = (sprint, index) => {
    setEpic(null);
    setSprint(sprint);
    setselectedEpicOrSprintIndex(index); // Save selected radio button index
  };

  // Select All: Add all objects from unassignedStories to selectedUnassignedUserStories
  const handleSelectAll = () => {
    setselectedUnassignedUserStories(unassignedStories);
  };

  // Deselect All: Clear the selectedUnassignedUserStories array
  const handleDeselectAll = () => {
    setselectedUnassignedUserStories([]);
  };

  // Toggle selection of individual objects
  const handleCheckboxChange = (story) => {
    setselectedUnassignedUserStories((prevSelected) => {
      // Check if the story is already selected
      const isSelected = prevSelected.some((item) => item.id === story.id);
      if (isSelected) {
        // Remove the story from selectedUnassignedUserStories
        return prevSelected.filter((item) => item.id !== story.id);
      } else {
        // Add the story to selectedUnassignedUserStories
        return [...prevSelected, story];
      }
    });
  };

  const startIndex = (currentUnassignedStoriesPage - 1) * storiesPerPage;
  const currentItems = unassignedStories.slice(
    startIndex,
    startIndex + storiesPerPage
  );

  // Check if a story is selected
  const isSelected = (story) => {
    return selectedUnassignedUserStories.some((item) => item.id === story.id);
  };

  const handleNavigate = () => {
    if (location.pathname === "/dashboard/userstory/input") {
      navigate("/dashboard/multi-userstory/output", {
        state: { userStories: selectedUnassignedUserStories, almConfig },
      });
    }
    if (location.pathname === "/dashboard/generate-testcases/input") {
      navigate("/dashboard/generate-multi/testcases/output", {
        state: { userStories: selectedUnassignedUserStories, almConfig },
      });
    }

    if (location.pathname === "/dashboard/test-plan") {
      setImportOpen(false);
      navigate("/dashboard/test-plan", {
        state: { userStories: selectedUnassignedUserStories, almConfig },
      });
    }
    //ROBOT FRAMEWORK
    if (location.pathname === "/dashboard/test-automation/robot-framework") {
      setImportOpen(false);
      navigate("/dashboard/test-automation/robot-framework", {
        state: {
          ...location.state,
          userStories: selectedUnassignedUserStories,
          almConfig,
        },
      });
    }
  };

  const handleCancel = () => {
    setImportOpen(false)
  }

  return (
    <ThemeProvider theme={theme}>
      <Dialog open>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column", // Adjust to column layout if you want content stacked vertically
            // alignItems: "center",
            justifyContent: "flex-start", // Allow content to stack without overflowing
            minHeight: "580px", // Minimum height ensures the box starts at this size
            backgroundColor: "#f8f9fa",
            fontFamily: "Roboto, sans-serif",
            overflow: "visible", // Ensure content is visible without hiding
            padding: "15px", // Optional padding to avoid content touching edges
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton
                  size="small"
                  sx={{ color: "black", "& svg": { fontSize: "0.9rem" } }}
                  onClick={handleBack}
                >
                  <ArrowBackIosNewIcon />
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "normal",
                    color: "black",
                    fontSize: "1.0rem",
                  }}
                >
                  Import User Stories
                </Typography>
              </Box>
              <Box>
                <IconButton onClick={handleCancel}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box sx={{ pt: 2, pl: 2, textAlign: "left" }}>
              <Typography
                variant="body2"
                sx={{ color: "black", fontSize: "1.0rem", textAlign: "left" }}
              >
                <strong>{selectedProjectName}</strong>
              </Typography>
            </Box>

            {/* Informative text*/}
            <Box sx={{ pl: 2 }}>
              {tabValue === 2 && (
                <Typography
                  variant="body2"
                  sx={{ color: "gray", fontSize: "0.8rem" }}
                >
                  Select one or multiple user stories to import
                </Typography>
              )}
              {tabValue !== 2 && (<Typography
                variant="body2"
                sx={{ color: "gray", fontSize: "0.8rem" }}
              >
                Select an epic, a sprint or standalone user stories to move forward.
              </Typography>)}

            </Box>
          </Box>

          {/*Tabs */}
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="User stories tabs"
            centered
          >
            <Tab label="Epics" sx={{ textTransform: "none" }} />
            <Tab label="Sprints " sx={{ textTransform: "none" }} />
            <Tab label="Standalone " sx={{ textTransform: "none" }} />
          </Tabs>

          <Box sx={{ flexGrow: 1 }}>
            {/* EPICS TAB */}
            <TabPanel value={tabValue} index={0}>
              {paginatedEpics.length > 0 ? (
                <RadioGroup
                  name="epic"
                  value={selectedEpicOrSprintIndex} // Controlled value
                // onChange={handleStorySelect}
                >
                  <Grid
                    container
                    spacing={4} // Ensures vertical spacing
                  //columnSpacing={0} // Removes horizontal spacing between columns
                  >
                    {Array.from({ length: 8 }).map((_, index) => {
                      const story = paginatedEpics[index];
                      return (
                        <Grid item xs={6} key={index}>
                          {story ? (
                            <Card
                              variant="outlined"
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%", // Ensure consistent height for all cards
                                p: 1,
                                overflow: "visible",
                              }}
                            >
                              <CardContent
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  height: "100%",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center", // Align radio and title on the same line
                                  }}
                                >
                                  <Radio
                                    value={index}
                                    size="small"
                                    sx={{ mr: 1 }} // Spacing between radio button and title
                                    onChange={() => handleEpics(story, index)} // Pass index and story
                                  />
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontSize: "0.85rem",
                                      fontWeight: "normal",
                                      whiteSpace: "normal",
                                      wordWrap: "break-word",
                                      flex: 1, // Ensure title takes available space
                                    }}
                                  >
                                    {story.title}
                                  </Typography>
                                </Box>
                                <Box>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                      fontSize: "0.75rem",
                                    }}
                                  >
                                    Status: <strong>{story.status}</strong>
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                      fontSize: "0.75rem",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    Last updated {story.lastUpdated}
                                  </Typography>
                                </Box>
                              </CardContent>
                            </Card>
                          ) : (
                            <Box
                              sx={{
                                height: "100%",
                                backgroundColor: "transparent",
                              }}
                            />
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                </RadioGroup>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                    fontSize: "1rem",
                    fontWeight: "bold",
                    color: "text.secondary",
                  }}
                >
                  {epicsAndSprintsLoading ? (
                    <CircularProgress />
                  ) : (
                    <Typography>
                      No Epics To display in the Selected Project
                    </Typography>
                  )}
                </Box>
              )}
              {/* Pagination for Epics */}
              <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
                <Pagination
                  count={totalEpicPages}
                  page={page}
                  onChange={(event, value) => setPage(value)}
                  sx={{
                    "& .MuiPaginationItem-root": { color: "black" },
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "light gray",
                      color: "black",
                    },
                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#f8f8f8",
                    },
                  }}
                />
              </Box>
            </TabPanel>

            {/* SPRINTS Tab */}
            <TabPanel value={tabValue} index={1}>
              {paginatedSprints.length === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px", // Adjust height as needed
                    fontSize: "1rem",
                    fontWeight: "bold",
                    color: "text.secondary",
                  }}
                >
                  {epicsAndSprintsLoading ? (
                    <CircularProgress />
                  ) : (
                    <Typography>
                      No Sprints To display in the Selected Project
                    </Typography>
                  )}
                </Box>
              ) : (
                <RadioGroup name="sprint" value={selectedEpicOrSprintIndex}>
                  <Grid container spacing={1}>
                    {/* Render sprints and placeholders */}
                    {Array.from({ length: 8 }).map((_, index) => {
                      const story = paginatedSprints[index];
                      return (
                        <Grid item xs={6} key={index}>
                          {story ? (
                            <Card
                              variant="outlined"
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                p: 1.2,
                                overflow: "visible", // Prevent content hiding
                                minHeight: "auto", // Adjust based on content
                              }}
                            >
                              <CardContent
                                sx={{
                                  p: 0,
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  flexGrow: 1,
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontSize: "0.85rem",
                                    fontWeight: "normal",
                                    marginBottom: 0.5,
                                    whiteSpace: "normal", // Allow text to wrap
                                    overflow: "visible",
                                  }}
                                >
                                  <Radio
                                    value={index}
                                    size="small"
                                    onChange={() => handleSprints(story, index)}
                                  />{" "}
                                  {story.title}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                      fontSize: "0.75rem",
                                    }}
                                  >
                                    Status: <strong>{story.status}</strong>
                                  </Typography>
                                </Box>
                              </CardContent>
                            </Card>
                          ) : (
                            // Placeholder for empty slots
                            <Box
                              sx={{
                                height: "60px",
                                backgroundColor: "transparent",
                              }}
                            />
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                </RadioGroup>
              )}
              {/* Pagination for Sprints */}
              <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
                <Pagination
                  count={totalSprintPages} // Hardcoded to 6 pages
                  page={page}
                  onChange={(event, value) => setPage(value)}
                  sx={{
                    "& .MuiPaginationItem-root": { color: "black" },
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "light gray",
                      color: "black",
                    },
                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#f8f8f8",
                    },
                  }}
                />
              </Box>
            </TabPanel>

            {/* Unassigned tab */}
            <TabPanel value={tabValue} index={2}>

              <Box sx={{ width: "520px", height: "300px" }}>
                {/* Select/Deselect Buttons */}
                {currentItems.length > 0 && (
                  <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    paddingY: 1
                  }}>
                    <Box sx={{ display: "flex", alignItems: "left" }}>
                      <Button
                        onClick={handleSelectAll}
                        sx={{ textTransform: "none", minWidth: "50px", paddingY: 1, }}
                        // startIcon={selectedUnassignedUserStories.length === unassignedStories.length ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                      >
                        Select all
                      </Button>
                      <Button
                        onClick={handleDeselectAll}
                        sx={{ textTransform: "none", minWidth: "50px", paddingY: 1 }}
                        // startIcon={selectedUnassignedUserStories.length === 0 ? <CheckBoxOutlineBlankIcon /> : <IndeterminateCheckBoxIcon />}
                        disabled={selectedUnassignedUserStories.length === 0}
                      >
                        Deselect all
                      </Button>
                    </Box>
                    {/* <Typography variant="body2" sx = {{color: 'grey'}}>
                      <span style={{ color: "black" }}>{selectedUnassignedUserStories.length}/</span>
                      <span style={{ color: "grey" }}>{unassignedStories.length}</span> Selected
                    </Typography> */}

                  </Box>

                )}

                {/* List of Checkbox Items */}
                <Box sx={{
                  flex: 1, overflow: "visible", backgroundColor: "#F0F8FF", border: "1px dashed #49A3FF",
                  borderRadius: "7px",
                  padding: "10px",
                  minBlockSize: "230px"
                }}>
                  {currentItems.length > 0 ? (
                    currentItems.map((story, idx) => (
                      <Box key={story.id || idx} sx={{ mb: 0.5, ml: 2 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isSelected(story)}
                              onChange={() => handleCheckboxChange(story)}
                              size="small"
                            />
                          }
                          label={
                            <Typography variant="body2">
                              {story.Title}
                            </Typography>
                          }
                          sx={{ alignItems: "center" }}
                        />
                        {/* <Divider sx={{ my: 0.5, width: "100%" }} /> */}
                      </Box>
                    ))
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "300px", // Adjust height as needed
                        fontSize: "1rem",
                        fontWeight: "bold",
                        color: "text.secondary",
                      }}
                    >
                      {epicsAndSprintsLoading ? (
                        <CircularProgress />
                      ) : (
                        <Typography>
                          No User Stories To display in the Selected Project
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>

                {/*UnAssigned User Stories Pagination */}
                {currentItems.length > 0 && (
                  <>

                    <Box
                      sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 2,
                      }}
                    >
                      {/* Left Side: Showing X/Y Items */}
                      <Typography
                        variant="body2"
                        sx={{
                          position: "absolute",
                          left: 0, // Aligns the count to the left
                        }}
                      >
                        {/* {startIndex + 1}-
                          {Math.min(
                            startIndex + ITEMS_PER_PAGE,
                            userStoryTitles.length
                          )}{" "}
                          of {userStoryTitles.length} Items */}
                        {currentItems.length}/{unassignedStories.length} Items

                      </Typography>

                      {/* Centered Pagination */}
                      <Pagination
                        count={totalUnassignedStoriesPage}
                        page={currentUnassignedStoriesPage}
                        onChange={(event, value) =>
                          setCurrentUnassignedStoiresPage(value)
                        }
                        sx={{
                          "& .MuiPaginationItem-root": { color: "black" },
                          "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: "lightgray",
                            color: "black",
                          },
                          "& .MuiPaginationItem-root:hover": {
                            backgroundColor: "#38608E14",
                          },
                        }}
                      />
                    </Box>


                    {/* Divider with no gaps */}
                    <Divider
                      sx={{
                        my: 2,
                        width: "calc(100% + 16px)",
                        marginLeft: "-10px",
                        marginRight: "-8px",
                      }}
                    />

                    {/* Dialog Actions */}
                    <DialogActions>
                      <Button
                        variant="contained"
                        onClick={handleNavigate}
                        // startIcon={<GenerateButton />}
                        disabled={selectedUnassignedUserStories.length <= 0} // Disable button if length <= 0
                        sx={{
                          backgroundColor: "#49A3FF",
                          textTransform: "none",
                        }}
                      >
                        Import
                      </Button>

                    </DialogActions>
                  </>
                )}
              </Box>
            </TabPanel>
          </Box>
        </Box>
      </Dialog>
    </ThemeProvider>
  );
}

export default Epics;
